export const QUOTE_COMMENT = 'quote_comment';
export const QUOTE_INTERNAL_NOTE = 'quote_internal_note';
export const QUOTE_CUSTOMER_NOTE = 'quote_customer_note';

export const QUOTE_NOTE_TYPES = [
    QUOTE_COMMENT,
    QUOTE_INTERNAL_NOTE,
    QUOTE_CUSTOMER_NOTE
]
